import { Text } from "@ui-component-library";
import { listClasses, listItemClasses } from "@ui-component-library/components/List/List.styles";
import { TailwindWrapper } from "@utils/TailwindWrapper";

export const ListPosts = (props: { items?: { text?: string }[] }) => (
  <TailwindWrapper>
    <div className="mx-auto mb-6 flex max-w-[720px] flex-col px-4 sm:px-6">
      <ul className={listClasses()}>
        {props.items?.length ? (
          props.items.map((row, index) => (
            <Text
              key={index}
              as="li"
              variant="text-base/leading-normal/normal"
              className={listItemClasses()}
            >
              {row.text}
            </Text>
          ))
        ) : (
          <>
            <Text as="li" variant="text-base/leading-normal/normal" className={listItemClasses()}>
              1:a, priser på gran går upp
            </Text>
            <Text as="li" variant="text-base/leading-normal/normal" className={listItemClasses()}>
              2:a, priser på grot fortsatt svagt
            </Text>
            <Text as="li" variant="text-base/leading-normal/normal" className={listItemClasses()}>
              3:e, priser på tall upp i Estland
            </Text>
          </>
        )}
      </ul>
    </div>
  </TailwindWrapper>
);

ListPosts.fields = {
  items: {
    type: "array",
    label: "List items",
    arrayFields: {
      text: { type: "text", label: "Text" },
    },
  },
};
